import {
    GET_BULK_ORDER_FLEET_HEADER,
    GET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    GET_BULK_ORDER_HEADER,
    GET_BULK_ORDER_PURCHASE_ORDER,
    GET_BULK_ORDER_VENDOR_DETAILS,
    GET_SAVE_VENDOR_DETAILS,
    SET_BULK_ORDER_ALERT,
    SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    SET_BULK_ORDER_FLEET_HEADER,
    SET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    SET_BULK_ORDER_HEADER,
    SET_BULK_ORDER_PURCHASE_ORDER,
    SET_BULK_ORDER_VENDOR_DETAILS,
    SET_SAVE_VENDOR_DETAILS,
    SAVE_BULK_ORDER_FLEET_ASSET,
    SET_BULK_ORDER_FLEET_ASSET,
    SET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    GET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    GET_BULK_ORDER_EXCEL_DATA,
    SET_BULK_ORDER_EXCEL_DATA,
    GET_TASK_HEADER_DETAILS,
    SET_TASK_HEADER_DETAILS,
    GET_TASK_ITEM_DETAILS,
    SET_TASK_ITEM_DETAILS,
    GET_CREATE_BULK_PO_DETAILS,
    SET_CREATE_BULK_PO_DETAILS,
    GET_BULK_FLEET_HISTORY_TIMELINE,
    SET_BULK_FLEET_HISTORY_TIMELINE,
    SAVE_TASK_ASSIGNED_TO,
    SAVE_TASK_COMMENT,
    SET_TASK_ASSIGNED_TO,
    SET_TASK_COMMENT,
    SAVE_CANCEL_FLEET_ITEM,
    SET_CANCEL_FLEET_ITEM,
    SET_SAVE_BULK_FLEET_PURCHASE_DETAIL,
    SET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    GET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    SAVE_BULK_ORDER_FLEET_BARCODE,
    SET_BULK_ORDER_FLEET_BARCODE,
    SAVE_CANCEL_BULK_ORDER,
    SET_CANCEL_BULK_ORDER
} from "./PurchaseBulkOrderType"

const getBulkOrderHeader = (orderId: any) => ({
    type: GET_BULK_ORDER_HEADER,
    orderId
})

const setBulkOrderHeader = (orderDetails: any) => ({
    type: SET_BULK_ORDER_HEADER,
    orderDetails
});

const getBulkOrderFleetHeader = (fleetId: any) => ({
    type: GET_BULK_ORDER_FLEET_HEADER,
    fleetId
})

const setBulkOrderFleetHeader = (fleetDetails: any) => ({
    type: SET_BULK_ORDER_FLEET_HEADER,
    fleetDetails
});

const getBulkOrderFleetPurchaseDetail = (fleetId: any) => ({
    type: GET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    fleetId
})

const setBulkOrderFleetPurchaseDetail = (purchaseDetails: any) => ({
    type: SET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    purchaseDetails
});

const saveBulkOrderFleetAsset = (payload: any) => ({
    type: SAVE_BULK_ORDER_FLEET_ASSET,
    payload
})

const setBulkOrderFleetAsset = (assetDetails: any) => ({
    type: SET_BULK_ORDER_FLEET_ASSET,
    assetDetails
});

const getBulkOrderExcelData = (orderDetailId: any) => ({
    type: GET_BULK_ORDER_EXCEL_DATA,
    orderDetailId
})

const setBulkOrderExcelData = (excelData: any) => ({
    type: SET_BULK_ORDER_EXCEL_DATA,
    excelData
});

const getTaskHeaderDetails = (orderDetailId: any) => ({
    type: GET_TASK_HEADER_DETAILS,
    orderDetailId
})

const setTaskHeaderDetails = (headerDetails: any) => ({
    type: SET_TASK_HEADER_DETAILS,
    headerDetails
});

const getTaskItemDetails = (fleetDetailId: any) => ({
    type: GET_TASK_ITEM_DETAILS,
    fleetDetailId
})

const setTaskItemDetails = (itemDetails: any) => ({
    type: SET_TASK_ITEM_DETAILS,
    itemDetails
});

const saveTaskAssignedTo = (payload: any) => ({
    type: SAVE_TASK_ASSIGNED_TO,
    payload
});

const setTaskAssignedTo = (assignedTo: any) => ({
    type: SET_TASK_ASSIGNED_TO,
    assignedTo
});

const saveTaskComment = (payload: any) => ({
    type: SAVE_TASK_COMMENT,
    payload
});

const setTaskComment = (comment: any) => ({
    type: SET_TASK_COMMENT,
    comment
});

const saveCancelFleetItem = (payload: any) => ({
    type: SAVE_CANCEL_FLEET_ITEM,
    payload
});

const setCancelFleetItem = (res: any) => ({
    type: SET_CANCEL_FLEET_ITEM,
    res
});

const saveCancelBulkOrder = (payload: any) => ({
    type: SAVE_CANCEL_BULK_ORDER,
    payload
});

const setCancelBulkOrder = (res: any) => ({
    type: SET_CANCEL_BULK_ORDER,
    res
});

const getBulkOrderDescriptionDropdown = (orderDetailId: any) => ({
    type: GET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    orderDetailId
})

const setBulkOrderDescriptionDropdown = (dropdownList: any) => ({
    type: SET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    dropdownList
});

const saveBulkOrderFleetPurchaseDetail = (payload: any) => ({
    type: SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    payload
});

const setSaveBulkFleetPurchaseDetail = (isBulkFleetPurchaseDetailSaved: any) => ({
    type: SET_SAVE_BULK_FLEET_PURCHASE_DETAIL,
    isBulkFleetPurchaseDetailSaved
});

const getsaveBulkOrderFleetPurchaseOrder = (payload: any) => ({
    type: GET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    payload
});

const setSaveBulkFleetPurchaseOrder = (isBulkFleetPurchaseOrderSaved: any) => ({
    type: SET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    isBulkFleetPurchaseOrderSaved
});

const getBulkOrderVendorDetails = (orderDetailId: any) => {
    return ({
        type: GET_BULK_ORDER_VENDOR_DETAILS,
        orderDetailId
    })
};

const setBulkOrderVendorDetails = (bulkOrderVendorDetails: any) => ({
    type: SET_BULK_ORDER_VENDOR_DETAILS,
    bulkOrderVendorDetails
});

const getBulkOrderPurchaseOrder = (orderDetailId: any) => {
    return ({
        type: GET_BULK_ORDER_PURCHASE_ORDER,
        orderDetailId
    })
};

const setBulkOrderPurchaseOrder = (bulkOrderPurchaseOrder: any) => ({
    type: SET_BULK_ORDER_PURCHASE_ORDER,
    bulkOrderPurchaseOrder
});

const getSaveVendorDetails = (details: any) => {
    return ({
        type: GET_SAVE_VENDOR_DETAILS,
        details
    })
};

const setSaveVendorDetails = (isVendorDetailsSaved: any) => ({
    type: SET_SAVE_VENDOR_DETAILS,
    isVendorDetailsSaved
});

const setBulkOrderAlert = (bulkOrderAlert: any) => ({
    type: SET_BULK_ORDER_ALERT,
    bulkOrderAlert
});

const getCreatePODetails = (orderDetails: any, orderDetailId: any) => ({
    type: GET_CREATE_BULK_PO_DETAILS,
    orderDetails,
    orderDetailId
})

const setCreatePODetails = (createdBulkPODetails: any) => ({
    type: SET_CREATE_BULK_PO_DETAILS,
    createdBulkPODetails
});

const getBulkFleetHistoryTimeLine= (OrderRequestId: any) => ({
    type: GET_BULK_FLEET_HISTORY_TIMELINE,
    OrderRequestId
})

const setBulkFleetHistoryTimeLine = (bulkFleetHistoryTimeLine: any) => ({
    type: SET_BULK_FLEET_HISTORY_TIMELINE,
    bulkFleetHistoryTimeLine
});

const saveBulkOrderFleetBarcode = (payload: any) => ({
    type: SAVE_BULK_ORDER_FLEET_BARCODE,
    payload
})

const setBulkOrderFleetBarcode = (response: any) => ({
    type: SET_BULK_ORDER_FLEET_BARCODE,
    response
});

export {
    getBulkOrderHeader,
    setBulkOrderHeader,
    getBulkOrderFleetHeader,
    setBulkOrderFleetHeader,
    getBulkOrderFleetPurchaseDetail,
    setBulkOrderFleetPurchaseDetail,
    getBulkOrderDescriptionDropdown,
    setBulkOrderDescriptionDropdown,
    saveBulkOrderFleetAsset,
    setBulkOrderFleetAsset,
    getBulkOrderExcelData,
    setBulkOrderExcelData,
    getTaskHeaderDetails,
    setTaskHeaderDetails,
    getTaskItemDetails,
    setTaskItemDetails,
    saveTaskAssignedTo,
    setTaskAssignedTo,
    saveTaskComment,
    setTaskComment,
    saveCancelFleetItem,
    setCancelFleetItem,
    saveBulkOrderFleetPurchaseDetail,
    getBulkOrderVendorDetails,
    setBulkOrderVendorDetails,
    getBulkOrderPurchaseOrder,
    setBulkOrderPurchaseOrder,
    getSaveVendorDetails,
    setSaveVendorDetails,
    setBulkOrderAlert,
    getCreatePODetails,
    setCreatePODetails,
    getBulkFleetHistoryTimeLine,
    setBulkFleetHistoryTimeLine,
    setSaveBulkFleetPurchaseDetail,
    setSaveBulkFleetPurchaseOrder,
    getsaveBulkOrderFleetPurchaseOrder,
    saveBulkOrderFleetBarcode,
    setBulkOrderFleetBarcode,
    setCancelBulkOrder,
    saveCancelBulkOrder
}